import { NgModule,NO_ERRORS_SCHEMA,CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpModule } from '@angular/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
// modules
import { Ng2TableModule } from 'ng2-table';
import { PaginationModule } from 'ng2-bootstrap';
import { MultiselectDropdownModule } from 'angular-2-dropdown-multiselect';
import { MatButtonModule, MatCheckboxModule, MatRadioModule, MatSelectModule } from '@angular/material';
import { NgUploaderModule } from 'ngx-uploader';
import { AngularMultiSelectModule } from 'angular2-multiselect-dropdown/angular2-multiselect-dropdown';
import { MyDatePickerModule } from 'mydatepicker';
import { LoadingModule } from 'ngx-loading';
import { ChartsModule } from 'ng2-charts';
import { NgxSelectModule } from 'ngx-select-ex';
import { PasswordStrengthBarModule } from 'ng2-password-strength-bar';
import {AutoCompleteModule} from 'primeng/autocomplete';
import {PipesModule} from '../pipes/pipes.module';
import { AlertComponent } from '../alert/alert.component';
import {NgxPaginationModule} from 'ngx-pagination';
import { AccordionModule } from "ngx-bootstrap";
import { OrderModule } from 'ngx-order-pipe';
import { AgGridModule } from 'ag-grid-angular';


@NgModule({
    imports: [
      CommonModule,
      HttpModule,
      ReactiveFormsModule,
      FormsModule,
      MultiselectDropdownModule,
      MatRadioModule,
      NgxPaginationModule,
      PaginationModule.forRoot(),
      AccordionModule.forRoot(),
      AgGridModule.forRoot(),
      HttpClientModule
    ],
    declarations: [
      AlertComponent
    ],
    exports: [
        HttpModule,
        PipesModule,
        Ng2TableModule,
        PaginationModule,
        MultiselectDropdownModule,
        MatButtonModule, 
        MatCheckboxModule,
        MatRadioModule,
        MatSelectModule,
        NgUploaderModule,
        AngularMultiSelectModule,
        MyDatePickerModule,
        LoadingModule,
        ChartsModule,
        NgxSelectModule,
        PasswordStrengthBarModule,
        AutoCompleteModule,
        ReactiveFormsModule,
        FormsModule,
        NgxPaginationModule,
        AlertComponent,
        AccordionModule,
        OrderModule,
        AgGridModule
    ],
    providers: [
    
    ]
    
  })
  export class SharedModule {
  }
  


// WEBPACK FOOTER //
// ./src/app/sharedModules/shared.module.ts